import { useLanguage } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "./ui/button";

// Branded loading — calm, no fake progress, no learner-analysis implication, reduced-motion safe.
export function BrandLoading() {
  const { lang } = useLanguage();
  return (
    <div className="min-h-screen bg-[#FBFBF9] flex items-center justify-center px-6" role="status" aria-live="polite" data-testid="brand-loading">
      <div className="text-center">
        <span aria-hidden="true" className="mx-auto block h-1 w-40 rounded-full overflow-hidden bg-[#D8E3DC]">
          <span className="block h-full w-1/3 bg-[#1E3A2B] motion-safe:animate-[edgeslide_1.4s_ease-in-out_infinite]" />
        </span>
        <p className="mt-5 font-heading text-sm font-semibold text-[#1A1F1C]">Reach New Edge™</p>
        <p className="mt-1 text-sm text-[#5B655F]">{lang === "sv" ? "Laddar…" : "Loading…"}</p>
      </div>
    </div>
  );
}

// Branded recoverable error — comprehensible next action; no stack traces / provider / internal detail.
export function BrandError({ onRetry, unauthorized = false }) {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const sv = lang === "sv";
  return (
    <div className="min-h-screen bg-[#FBFBF9] flex items-center justify-center px-6" data-testid="brand-error">
      <div className="max-w-md text-center">
        <span aria-hidden="true" className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#D8E3DC]"><Compass className="h-6 w-6 text-[#1E3A2B]" /></span>
        <h1 className="mt-6 font-heading text-2xl font-semibold text-[#1A1F1C]">
          {unauthorized ? (sv ? "Du har inte behörighet." : "You don't have access.") : (sv ? "Något gick tillfälligt fel." : "Something went wrong.")}
        </h1>
        <p className="mt-3 text-base text-[#525B56]">
          {unauthorized ? (sv ? "Den här sidan kräver att du är inloggad med rätt behörighet." : "This page requires you to be signed in with the right access.") : (sv ? "Försök igen om en liten stund. Din väg framåt finns kvar." : "Please try again in a moment. Your path forward is still here.")}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {unauthorized ? (
            <Button data-testid="brand-error-signin" onClick={() => navigate("/login")} className="rounded-full bg-[#1E3A2B] hover:bg-[#14281E] text-[#FBFBF9] px-6">{sv ? "Logga in igen" : "Sign in again"}</Button>
          ) : (
            <Button data-testid="brand-error-retry" onClick={() => (onRetry ? onRetry() : window.location.reload())} className="rounded-full bg-[#1E3A2B] hover:bg-[#14281E] text-[#FBFBF9] px-6">{sv ? "Försök igen" : "Try again"}</Button>
          )}
          <Button data-testid="brand-error-home" variant="outline" onClick={() => navigate("/")} className="rounded-full px-6">{sv ? "Till startsidan" : "Return home"}</Button>
        </div>
      </div>
    </div>
  );
}
